import View from '@/base/views/view';

class AutoTestResult extends View {
    
    static table = 'autotestresult';

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        const customerField = res.fields.find(f => f.name === 'CustomId')
        const createdUTCField = res.fields.find(f => f.name === 'CreatedUTC')
        const MessageField = res.fields.find(f => f.name === 'Message')

        if (createdUTCField) {
            createdUTCField.hidden = false
            createdUTCField.hideFromList = false
        }

        if (customerField) {
            customerField.label = 'Customer'
            customerField.relation = 'customer'
            customerField.optionLabels = 'Name'
            customerField.editor = 'vue-select'
            customerField.filters = (r) => {return r.Project.Name == 'Nubbo'}
        }

        if (MessageField) {
            MessageField.editor = 'component'
            MessageField.component = 'json-editor'
            MessageField.hideFromList = true
            MessageField.headerField = true
        }
        res.canAdd = true;
        return res;
    }

}

export default AutoTestResult;